<div style="text-align: right; margin-bottom: -1.375rem;">
  <span (click)="closeDialog()" class="closeButton">&#10005;</span>
</div>
<div style="text-align: center; margin-top: 2.688rem;">
  <span style="color: #4c4c4c; font-size: 1.688rem;">Does this project require non-standard activities?</span>
</div>
<div style="text-align: center; margin-top: 2.5rem;">
  <div style="display: inline-block; margin-right: 1.5rem;">
    <div class="exitButton" (click)="noClicked()">
      <span class="exitText">NO</span>
    </div>
  </div>
  <div style="display: inline-block;">
    <div style="display: inline-block">
      <button class="confirmButton" (click)="yesClicked()">
        <span class="confirmText">YES</span>
      </button>
    </div>
  </div>
</div>
<div style="text-align: center; margin-top: 2.5rem;">
  <div class="startOverButton"> 
    <span style="font-size: 0.875rem; color: #00789E;">I'M NOT SURE</span>
    <div class="notSureTooltip">
      <div style="width: 20.875rem; margin-bottom: 1.125rem;">
        <span><span class="text-bold">Standard Activities include</span>  I (Install / CWIP), R (Removal / RWIP), E (Engineering), and X (O&M) and will be defaulted based on the Project Charge Indicator selected on the previous page.</span>
      </div>
      <div style="width: 20.875rem">
        <span><span class="text-bold">Non-Standard Activities</span> require the manual selection of more detailed Activities.</span>
      </div>
    </div>
  </div>
</div>